import { React, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import Navbar from "./Navbar";
import Avatar from "../../assets/avatarr.jpeg";
import SolarPanel from "../../assets/solar-panel.png";

function AdminPage() {
  const navigate = useNavigate();
  const [imagePreviewUrl, setImagePreviewUrl] = useState(Avatar);

  const handleImageChange = (e) => {
    e.preventDefault();

    let reader = new FileReader();
    let file = e.target.files[0];

    reader.onloadend = () => {
      setImagePreviewUrl(reader.result);
    };

    if (file) {
      reader.readAsDataURL(file);
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const name = document.getElementById("name").value;
    const email = document.getElementById("email").value;
    const password = document.getElementById("password").value;
    const phone = document.getElementById("phone").value;
    const company = document.getElementById("company").value;
    const vat = document.getElementById("vat").value;

    const url = "/api/update";

    fetch(url, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        name: name,
        email: email,
        password: password,
        phone_number: phone,
        company: company,
        company_vat_number: vat,
      }),
    })
      .then((response) => response.json())
      .then((data) => {
        if (data.data === "User details updated successfully") {
          alert("Profile updated successfully");
        } else {
          alert("Error updating profile");
        }
      })
      .catch((error) => {
        console.error("Error:", error);
      });
  };

  useEffect(() => {
    fetchProfile();
    async function fetchProfile() {
      const response = await fetch("/api/profile", {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
        },
        credentials: "include",
      });

      const data = await response.json();
      if (!response.ok) {
        alert("Error fetching profile data");
        return;
      }

      document.getElementById("name").value = data.data.name;
      document.getElementById("email").value = data.data.email;
      document.getElementById("password").value = data.data.password;
      document.getElementById("phone").value = data.data.phone_number;
      document.getElementById("company").value = data.data.company;
      document.getElementById("vat").value = data.data.company_vat_number;
    }
  }, []);

  return (
    <div className="bg-white text-black">
      <Navbar />

      {/* Main content */}
      {/* <div className="max-w-7xl mx-auto py-6 sm:px-6 lg:px-8 flex justify-between items-start"> */}
      <div className="max-w-7xl mx-auto py-6 sm:px-6 lg:px-8 grid grid-cols-2 gap-4">
        {/* <div className="max-w-7xl mx-auto py-6 sm:px-6 lg:px-8"> */}
        <div className="px-4 py-4 sm:px-0">
          <h1 className="text-3xl font-bold mb-4">Profile</h1>

          {/* Image upload section */}
          <div className="mb-4">
            {imagePreviewUrl && (
              <label htmlFor="image">
                <img
                  src={imagePreviewUrl}
                  alt="Preview"
                  className="w-24 h-24 rounded-full"
                />
              </label>
            )}
            <input
              type="file"
              id="image"
              className="hidden"
              // className="w-80 p-2 border border-gray-300 rounded-lg text-black"
              onChange={handleImageChange}
            />
          </div>

          {/* Edit fields section */}
          <div className="mb-4">
            <label className="block mb-1" htmlFor="name">
              Name
            </label>
            <input
              type="text"
              id="name"
              className="w-80 p-2 border border-gray-300 rounded-lg text-black"
            />
          </div>
          {/*password */}
          <div className="mb-4">
            <label className="block mb-1" htmlFor="password">
              Password
            </label>
            <input
              type="email"
              id="password"
              className="w-80 p-2 border border-gray-300 rounded-lg text-black"
            />
          </div>

          {/* Add other fields here (phone no, company, email, company vat number) */}
          <div className="mb-4">
            <label className="block mb-1" htmlFor="email">
              Email
            </label>
            <input
              type="email"
              id="email"
              className="w-80 p-2 border border-gray-300 rounded-lg text-black"
              disabled
            />
          </div>
          <div className="mb-4">
            <label className="block mb-1" htmlFor="phone">
              Phone Number
            </label>
            <input
              type="text"
              id="phone"
              className="w-80 p-2 border border-gray-300 rounded-lg text-black"
            />
          </div>
          <div className="mb-4">
            <label className="block mb-1" htmlFor="company">
              Company
            </label>
            <input
              type="text"
              id="company"
              className="w-80 p-2 border border-gray-300 rounded-lg text-black"
              disabled
            />
          </div>
          <div className="mb-4">
            <label className="block mb-1" htmlFor="vat">
              Company VAT Number
            </label>
            <input
              type="text"
              id="vat"
              className="w-80 p-2 border border-gray-300 rounded-lg text-black"
            />
          </div>
          {/* End of fields section */}

          {/* Submit button */}
          <button
            type="submit"
            className="bg-[#2d9376] text-white py-2 px-4 rounded-lg hover:bg-green-600"
            onClick={handleSubmit}
          >
            Save Changes
          </button>
        </div>
        <div>
          {/* This div will not grow but will accommodate the image size */}
          <img
            src={SolarPanel}
            alt="Solar Panel"
            className="w-full h-auto"
          />{" "}
          {/* Adjust width as needed */}
        </div>
      </div>
    </div>
  );
}

export default AdminPage;
